import React, { useState } from "react";
import { accountType } from "../../utils/data/account_type";
import EditAccount from "../modals/accounting/EditAccount";
import PaginationLinks from "./../pagination/PaginationLinks";
import { BounceLoader } from "react-spinners";
import { v4 as uuidv4 } from "uuid";
import Loading from "../loader/Loading";

const ChartOfAccountTable = ({
  accounts,
  isSearching,
  isLoading,
  fetchAccounts,
}) => {
  const [singleAccount, setSingleAccount] = useState(null);

  return (
    <div className='position-relative'>
      <div className='table-responsive mt-3 '>
        <table className='table table-centered table-striped no-footer'>
          <thead>
            <tr>
              <th
                className='sorting'
                tabIndex='0'
                rowSpan='1'
                colSpan='1'
                style={{ width: "120.8px" }}
                aria-label='Customer: activate to sort column ascending'
              >
                GL Code
              </th>
              <th
                className='sorting'
                tabIndex='0'
                rowSpan='1'
                colSpan='1'
                style={{ width: "144.8px" }}
                aria-label='Phone: activate to sort column ascending'
              >
                Account Name
              </th>
              <th
                className='sorting'
                tabIndex='0'
                rowSpan='1'
                colSpan='1'
                style={{ width: "100.8px" }}
                aria-label='Email: activate to sort column ascending'
              >
                Account Type
              </th>
              <th
                className='sorting'
                tabIndex='0'
                rowSpan='1'
                colSpan='1'
                style={{ width: "100.8px" }}
                aria-label='Location: activate to sort column ascending'
              >
                External ID
              </th>
              <th
                className='sorting'
                tabIndex='0'
                rowSpan='1'
                colSpan='1'
                style={{ width: "100.8px" }}
                aria-label='Status: activate to sort column ascending'
              >
                Balance
              </th>
              <th style={{ width: "85.8px" }} className='text-center'>
                Action
              </th>
            </tr>
          </thead>

          {accounts?.data?.length ? (
            <>
              <tbody>
                {accounts?.data?.map((item, i) => (
                  <tr key={i}>
                    <td className='text-capitalize'>{item?.gl_code}</td>
                    <td className='text-capitalize'>{item?.account_name}</td>
                    <td className='text-capitalize'>
                      {accountType[item?.account_type - 1]?.toLowerCase()}
                    </td>
                    <td>
                      {item?.external_id === null ? "-" : item?.external_id}
                    </td>
                    <td>{item?.balance}</td>
                    <td className='p-0 text-center'>
                      <span
                        onClick={() =>
                          setSingleAccount({ ...item, uuid: uuidv4() })
                        }
                      >
                        <i
                          className='mdi mdi-pencil fs-4 text-primary-1 cursor-p '
                          data-bs-toggle='modal'
                          data-bs-target='#staticBackdrop8'
                        ></i>
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </>
          ) : (
            ""
          )}
        </table>
      </div>
      {isSearching && isLoading && <Loading />}

      <EditAccount
        modal_id={"staticBackdrop8"}
        singleAccount={singleAccount}
        setSingleAccount={setSingleAccount}
      />
      {accounts?.data?.length ? (
        <div className='row mt-4'>
          <div className='col-sm-12 col-md-6'>
            <div
              className='dataTables_info table-pages'
              id='products-datatable_info'
              role='status'
              aria-live='polite'
            >
              Showing accounts {accounts?.from} to {accounts?.to} of{" "}
              {accounts?.total}
            </div>
          </div>

          <div className='col-sm-12 col-md-6'>
            <PaginationLinks
              paginationData={accounts}
              getNextPage={fetchAccounts}
            />
          </div>
        </div>
      ) : (
        <p className='alert alert-info'>No records found!</p>
      )}
    </div>
  );
};

export default ChartOfAccountTable;
